import { useT } from '@/i18n'

/** Analitika ekranlari uchun kichik CSV-eksport tugmasi (PageHeader `actions`да). */
export function CsvButton({ onClick }: { onClick: () => void }) {
  const t = useT()
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
    >
      {t.table.export}
    </button>
  )
}
